export const environment = {
  production: false,
  title: 'homologation',
  version: '0.34.0',
  cryptKey: 'e9b7cf90ed0b28e160c41951c74af9dc',
  inativityLimitTime: 300,
  api: {
    baseUrl: 'https://pat-api-hml-dot-otwonco-hml.rj.r.appspot.com/'
  },
  firebase: {
    apiKey: "AIzaSyAmrrgIow7K6vqTPF6ipMg2FTMqGzTU5kc",
    authDomain: "otwonco-hml.firebaseapp.com",
    databaseURL: "https://otwonco-hml.firebaseio.com",
    projectId: "otwonco-hml/",
    storageBucket: "otwonco-hml.appspot.com",
    messagingSenderId: "155685079667",
    appId: "1:155685079667:web:0323dce35c8787977cb806"
  },
  patientUrl : 'https://pat-api-hml-dot-otwonco-hml.rj.r.appspot.com/',
  questionnaireUrl : 'https://quest-api-hml-dot-otwonco-hml.rj.r.appspot.com/',
  backendUrl: 'https://us-central1-otwonco-hml.cloudfunctions.net/',
  datastore : 'ccc-datastore-hml-r4/'
};
